<template>
  <DataList
    title="Джерела Коштів"
    resource="payment-sources"
    :columns="columns"
    :get-items-fn="getPaymentSources"
    :search-label="'Пошук за назвою джерела коштів'"
  />
</template>

<script>
import * as sourcesApi from "../../../backend/sourcesApi.js";

export default {
  data: () => ({
    columns: [
      { title: "id", name: "id" },
      { title: "Найменування", name: "title" },
      { title: "Номер Рахунка", name: "accountNumber" },
      {
        title: "Тип Оплати",
        name: "paymentType",
        component: "PaymentTypeLabel",
      },
    ],
  }),
  methods: {
    getPaymentSources(...args) {
      return sourcesApi.getPaymentSources(args[0], args[1], args[2], args[3]);
    },
  },
};
</script>
